// Funciones puras para armar las líneas (renglones) del pedido.

export const crearLineaVacia = (uuidPedido) => ({
  uuid_pedido: uuidPedido,
  producto: null,
  cantidad: 1,
  especificaciones: "",
  promo: 0,
  sena: 0,
});

// Línea de envase: "tipo" sólo se usa en pantalla (elige la lista de productos
// y la UI); no se envía al guardar.
export const crearLineaEnvase = (uuidPedido) => ({
  ...crearLineaVacia(uuidPedido),
  tipo: "envase",
});

// Igual que el original: las líneas de productos predeterminados no llevan
// promo/sena (se envían sin esos campos). Si no hay predeterminados se arranca
// con una línea vacía.
export const lineasDesdePredeterminados = (predeterminados, uuidPedido) => {
  const lineas = predeterminados.map((producto) => ({
    uuid_pedido: uuidPedido,
    producto: producto.id_producto,
    cantidad: 1,
    especificaciones: "",
  }));
  return lineas.length === 0 ? [crearLineaVacia(uuidPedido)] : lineas;
};

// "Promo / Seña" es una sola marca, como en la app: se guarda en promo
// (entrega_sena queda siempre en 0).
export const marcarPromoSena = (linea, checked) => ({
  ...linea,
  promo: checked ? 1 : 0,
  sena: 0,
});

// Se contempla sena === 1 por compatibilidad con líneas marcadas con el
// esquema anterior de dos botones.
export const esPromoOSena = (linea) => linea.promo === 1 || linea.sena === 1;

// Una sola promo/seña por producto: ¿hay OTRA línea del mismo producto marcada?
export const tieneOtraPromo = (lineas, index) => {
  const producto = lineas[index]?.producto;
  if (producto === null || producto === undefined) return false;
  return lineas.some((linea, i) => i !== index && linea.producto === producto && esPromoOSena(linea));
};

export const hayPromoDuplicada = (lineas) =>
  lineas.some((linea, i) => esPromoOSena(linea) && tieneOtraPromo(lineas, i));

// La cantidad debe ser un entero >= 1 (llega como número o como string del input).
export const esCantidadValida = (cantidad) => {
  const texto = String(cantidad ?? "").trim();
  return /^\d+$/.test(texto) && Number(texto) >= 1;
};

// Regla para habilitar "Guardar": cliente y dirección elegidos, al menos una
// línea, todas con producto y cantidad válida, y sin promo/seña repetida por producto.
export const puedeGuardar = (clienteSeleccionado, direccionSeleccionada, lineas) => {
  const hasNullProduct = lineas.some((item) => item.producto === null);
  const hasCantidadInvalida = lineas.some((item) => !esCantidadValida(item.cantidad));
  return !(
    Object.keys(clienteSeleccionado).length === 0 ||
    Object.keys(direccionSeleccionada).length === 0 ||
    lineas.length === 0 ||
    hasNullProduct ||
    hasCantidadInvalida ||
    hayPromoDuplicada(lineas)
  );
};
